import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromAuthReducer from '../reducers/auth.reducer';

export const selectAuthFeature = createFeatureSelector<fromAuthReducer.AuthState>('auth');

export const selectAuth = createSelector(selectAuthFeature, (state: fromAuthReducer.AuthState) => ({
  ...state,
}));

export const getAuthRefreshToken = createSelector(
  selectAuth,
  fromAuthReducer.selectAuthRefreshToken,
);

export const getAuthAccessToken = createSelector(selectAuth, fromAuthReducer.selectAuthAccessToken);

export const getAuthError = createSelector(selectAuth, fromAuthReducer.selectAuthError);

export const getResetStatus = createSelector(selectAuth, fromAuthReducer.selectResetStatus);

export const getVerificationStatus = createSelector(selectAuth, fromAuthReducer.selectVerifyStatus);

export const getAuthLoaded = createSelector(selectAuth, fromAuthReducer.selectLoaded);
